import React__default from 'react';

const width = 22;
const height = 20;
const IconExplore = ({ fill = "black", size = 1 }) => {
    return (React__default.createElement("svg", { width: size * width, height: size * height, viewBox: "0 0 22 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React__default.createElement("path", { d: "M16.5542 3.05991L14.913 4.15411L16.6529 8.50099L18.6362 7.91891L16.5542 3.05991ZM13.2129 5.28601L3.28916 11.9029L3.52016 12.3649L14.7249 9.06801L13.2129 5.28601ZM17.4457 0.0620117L21.3631 9.20241L13.9959 11.369L16.9611 19.2519L15.0884 19.9542L12.0719 11.935L10.7159 12.333L7.9193 19.9548L6.08101 19.167L8.33094 13.035L2.47982 14.7563L0.710938 11.2185L17.4457 0.0620117Z", fill: fill })));
};

export { IconExplore as default };
//# sourceMappingURL=IconExplore.js.map
